<template>
  <li>
    <router-link :to="{ name: 'graduates.placements.single', params: { graduateId: placement.graduate_id, placementId: placement.id } }">
      <div class="row">
        <div class="col">
          <p class="strong">{{ placement.graduate.name }}</p>
          <ul class="details">
            <li>Program: {{ placement.program.name }}</li>
            <li>Placement: {{ placement.number }}</li>
            <li v-if="$userIsCoordinator">Manager: {{ placement.manager ? placement.manager.name : 'Unassigned' }}</li>
            <li v-if="placement.underperforming && placement.number !== 1">
              <span
                class="badge badge-warning"
                data-toggle="tooltip"
                data-placement="top"
                title="Please check previous PDP for specific capabilities"
              >Capabilities Requiring Development</span>
            </li>
          </ul>
        </div>
        <div class="col-auto d-flex align-items-center">
          <span v-if="showOverdue" class="status status-danger">Overdue</span>
          <span v-else-if="!showOverdue && showOpen" class="status status-success">Open</span>
        </div>
      </div><!-- /.row -->
    </router-link>
  </li>
</template>

<script>
import { helpers } from 'mixins/placements'
export default {
  mixins: [helpers],

  props: {
    placement: {
      required: true,
      type: Object
    }
  },

  computed: {
    /**
     * Show overdue text if either the start or end component is 'contextually' overdue. (see the placement model on api)
     */
    showOverdue () {
      return this.placementStartComponentIsContextuallyOverdue || this.placementEndComponentIsContextuallyOverdue
    },

    /**
     * Show open text if either the start or end component is 'contextually' open && is pending review
     */
    showOpen () {
      return (this.placementStartComponentIsContextuallyOpen && this.placementStartComponentIsPendingReview) ||
        (this.placementEndComponentIsContextuallyOpen && this.placementEndComponentIsPendingReview)
    }
  }
}
</script>
